// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper_1UHvH","header":"Search_header_sFlxc","searchRow":"Search_searchRow_2E06G"};